import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Pagination from '../../components/_Pagination';
import Loading from '../../components/Loading';
import { load } from '../../actions/certificates';
import Item from './Item';

const mapStateToProps = ({ certificates, user }) => ({
  permissions: user.permissions || [],
  page: certificates.page,
  itemsPerPage: certificates.itemsPerPage,
  list: certificates.list,
  count: certificates.count,
  isLoaded: certificates.isLoaded,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  loadContent: load,
}, dispatch);

const Certificates = ({ permissions, page, itemsPerPage, list, count, isLoaded, loadContent, onSelect }) => {
  useEffect(() => {
    loadContent(page);
  }, []);

  if (!permissions.includes('MY_CERTIFICATES_LIST'))
    return null;

  return (
    <div style={{ position: 'relative' }}>
      {!isLoaded && <Loading />}
      {!!list.length && (
        <React.Fragment>
          <div className="tiles">{list.map(item => (
            <Item key={item.storage_id} item={item} onSelect={onSelect} />))}
          </div>
          <Pagination
            activePage={page}
            itemsPerPage={itemsPerPage}
            totalItems={count}
            onChange={loadContent}
          />
          <div className="clear10" />
        </React.Fragment>)}
    </div>
  );
};

Certificates.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  page: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  list: PropTypes.arrayOf(PropTypes.any).isRequired,
  count: PropTypes.number.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  loadContent: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Certificates);



// WEBPACK FOOTER //
// ./src/views/_Certificates/index.js